<template>
	<div class="projects-container">
		<div class="projects-content">

<!------------------------------------------------------------------------------------------------- -->
			<div class="header">
			  <div class="fadeInDown animated">	
				<button :class="{'active-btn': (projects==1)}" @click="projects=1">
					<i class="fas fa-desktop" style="font-size: 18px;"></i>
                    <p style="font-size: 10px; font-family:comfortaa;">WEB</p>
				</button>
				<button :class="{'active-btn': (projects==2)}" @click="projects=2">
					<i class="fas fa-mobile" style="font-size: 18px;"></i>
                    <p style="font-size: 10px;font-family:comfortaa;">MOBILE</p>
				</button>
				
			  </div>
			</div>

<!------------------------------------------------------------------------------------------------- -->

		   <!-- WEB -->


			<div class="container " v-if="projects==1">

               <div class="row">  

				 
				<!------------------------------------------------------------------------------------------------ - --> 	
                   <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="card-cover ">
                             	    <a href="https://rkrs.rocks" target="_blank" class="animated fadeInUp">
                                  <img class="A" src="src/assets/img/MP.png" alt="">
                                  <img class="B" src="src/assets/img/MPr.png" alt="">
                                  </a> 
                                           
                             </div>                       
                     
                   </dir>
                <!------------------------------------------------------------------------------------------------ - -->
                   <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="card-cover ">
                             	<a href="https://codepen.io/rkrshen/pen/RJbWPJ" target="_blank" class="animated fadeInUp">
                                  <img class="A" src="src/assets/img/MB.png" alt="">
                                  <img class="B" src="src/assets/img/MBr.png" alt=""> 

                                  </a>          
                             </div>                       
                     
                   </dir>

                <!------------------------------------------------------------------------------------------------- -->
                 <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="card-cover ">
                             	<a href="https://codepen.io/rkrshen/pen/YLNBNR" target="_blank" class="animated fadeInUp">
                                  <img class="A" src="src/assets/img/MCT.png" alt=""> 
                                  <img class="B" src="src/assets/img/MCTr.png" alt="">
                                  </a>          
                             </div>                       
                     
                   </dir>

                <!------------------------------------------------------------------------------------------------- -->
                   <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="card-cover ">
                             	<a href="https://codepen.io/rkrshen/pen/NMrKmL" target="_blank" class="animated fadeInUp">
                                  <img class="A" src="src/assets/img/SJ.png" alt=""> 
                                  <img class="B" src="src/assets/img/SJr.png" alt=""> 
                                  </a>          
                             </div>                       
                     
                   </dir>
                   <!------------------------------------------------------------------------------------------------- -->
                   <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="card-cover ">
                             	<a href="https://codepen.io/rkrshen/pen/mxvwWb" target="_blank" class="animated fadeInUp">
                                  <img class="A" src="src/assets/img/PC.png" alt=""> 
                                  <img class="B" src="src/assets/img/PCr.png" alt=""> 

                                  </a>          
                             </div>                       
                     
                   </dir>
          	    

               </div>
			</div>

<!------------------------------------------------------------------------------------------------ - -->

			<!-- MOBILE -->
			<div class="container " v-if="projects==2">

               <div class="row">  

                <!------------------------------------------------------------------------------------------------- -->
                   <dir class="col-sm-12 col-md-6 col-lg-4 col-xl-4 zoomIn animated">
                    
                             <div class="mobile-cover ">
                             	<a href="" target="_blank" class="animated fadeInUp">
                                  <img src="src/assets/img/myworkout.png" alt=""> 
                                  </a>          
                             </div>                       
                     
                   </dir>


                
          	    

               </div>
			</div>

<!------------------------------------------------------------------------------------------------- -->			



		</div>


	</div>
</template>



<style lang="scss">
.projects-container {
  width: 100%;
  margin-top: 13vh;
  a {
    color: #ccc;
    text-decoration: none;
  }
}

.projects-content {
  box-sizing: border-box;
  width: 100%;
  margin: auto;
}

.header {
  text-align: center; 
  margin-left: 50%;
  transform: translate(-50%);
  margin-bottom: 30px;

  button {
    background-color: transparent;
      
      text-align: center;
      border:none;
      cursor: pointer;
      outline: none;
      font-size: 20px;
      
      margin-left: 0px;
      color: #474747;  
  }

  .active-btn {
    background-color: transparent;
      text-align: center;
      border:none;
      cursor: pointer;
      outline: none;
      margin-left: 0px;
      color: #ff4d5a; 
  }
}





.card-cover {
	
     
     text-align: center;
     margin-bottom: 20px;
      box-shadow: 0 0 10px 2px #606060;
  
  img {
    width: 100%;
    height: auto;
        
  }
  .B{
      display: none;
    }
}

.card-cover:hover {
  
  
       .A{
        display: none;
       }
       .B{
        display: block;
       }
  
 
}

.mobile-cover {
  
     
     text-align: center;
     margin-bottom: 20px;
  
  img {
    
    height: 200px;
    width: auto;

    
  }
}

.active-btn {
  background: royalblue;
  transition: all 0.2s;
}



@media (max-width: 1069px) {
  .projects-content {
    padding-top: 90px;
  }
}

@media (max-width: 460px) {
  .projects-content {
    width: 100%;
    padding-right:0;
    padding-left:0;



    .header{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
}
</style>



<script>

import  { mapActions } from 'vuex'

export default {
  name: "projects",
  data() {
    return {
      projects: 1,
      
    }
  },

  methods : {
    ...mapActions({
      openModal : 'openModalAction',
    }),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects.vue